import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-widgets/Calendar';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  FormGroup,
  Input,
  Popover,
  PopoverHeader,
  PopoverBody,
  Progress,
} from 'reactstrap';
import FileSaver from 'file-saver';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Moment from 'moment';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import Loader from '../../../commons/loader';
import Services from './Services';
import HelyszinItem from '../../../components/Jegyezz/HelyszinItem';
import EsemenyItem from '../../../components/Jegyezz/EsemenyItem';
import KorhatarItem from '../../../components/Jegyezz/KorhatarItem';
import { DatePicker, PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit'
import JegyvasarlasContent from './JegyvasarlasContent';
import MultiColorProgressBar from '../../../components/Jegyezz/MultiColorProgressBar';
import Lib from '../../../commons/lib';
import momentLocalizer from "react-widgets-moment";
import TeremberlesFizetesUrlap from '../../Teremberles/TeremberlesFizetesUrlap';
import { useLocation } from 'react-router';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';
import MusorContentOsszetettKeresesFormField from './MusorContentOsszetettKeresesFormField';

// momentLocalizer(Moment);

const { ExportCSVButton } = CSVExport;

class MusorContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'QUERY']
      tableStatus: 'QUERY',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW']
      formFizetesStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // INIT
      initNow: TimeFormatter.formatDate(Moment()),
      initDays: 2,
      initLocations: [],
      activeLocation: {
        id: -1,
        ids: [],
        nev: '-'
      },
      // DATA
      baseJson: [],
      currentId: undefined,
      currentTeremberlesId: undefined,
      currentEmail: '',
      torlesId: undefined,
      torlesJegyId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalView: false,
      modalDelete: false,
      modalJegyDelete: false,
      modalEmail: false,
      modalFizetes: false,
      modalPayment: false,
      modalTeremBerlesFizetes: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      deleteJegyButtonLoading: false,
      emailButtonLoading: false,
      payButtonLoading: false,
      rendelesButtonLoading: false,
      listazasButtonLoading: false,
      xlsxButtonLoading: false,
      reszletesXlsxButtonLoading: false,
      tovabbButtonLoading: false,
      hasTorlesOka: false,
      isNaptarOpen: false,
      // ELOSZURES VALUES
      naptarValue: TimeFormatter.formatDate(Moment()),
      eloszuresSor: '',
      eloszuresHelyszin: '',
      eloszuresKezdete: TimeFormatter.formatDate(Moment()),
      eloszuresVege: TimeFormatter.formatDate(Moment()),
      eloszuresEloadas: '',
      eloszuresCim: '',
      eloszuresEmail: '',
      eloszuresRendelesTipus: '',
      eloszuresRendelesAllapot: '',
      // ELOSZURES UTILS
      eloszuresEloadasOptions: [],
      rendelesTipusOptions: [],
      rendelesAllapotOptions: [],
      eloszuresHelyszinOptions: [],
      eloszuresHelyszinOptionsData: [],
      eloszuresKereses: '',
      keresesType: 'NEVMAIL',
      osszetettKeresesButtonLoading: false,
      // FORM VALUES
      formElmultEsemenyek: false,
      formHelyszin: '',
      formRendeloNev: '',
      formRendeloEmail: '',
      formRendelesAllapot: '',
      formRendelesSorszam: '',
      formEsemenyKezdete: '',
      formEsemenyNev: '',
      formTerem: '',
      formTorlesOka: '',
      formTorlesJegyOka: '',
      formJegyadatok: [],
      // PAYMENT FORM VALUES
      formFizetestipus: '',
      forFizetestipusOptions: [],
      // HELYI FIZETÉS
      formCurrentHelyszin: null,
      formCurrentEsemeny: null,
      formHelyszinCards: [],
      formEsemenyCards: [],
      rendelesKezdete: TimeFormatter.formatDate(Moment()),
      rendelesVege: TimeFormatter.formatDate(Moment()),
      rendelesCime: '',
      showVasarlas: false,
      showSecondScreen: false,
      hasFizKarbRole: false,
    };

  }

  componentDidMount() {
    if (this.props.type === 'MUSOR') {
      this.init();
    }
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  goTo = (url, options) => {
    if (options) {
      this.props.globals.route.navigate(url, options)
    } else {
      this.props.globals.route.navigate(url);
    }
  }
  
  uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }

  init = () => {
    Services.getErtekesitesInit((errInit, resInit) => {
      if (!errInit) {
        let initDays = resInit[0].int;
        this.setState({
          hasFizKarbRole: this.props.globals.hasRoleSpec(['TEREMBERLES_FIZ_KARB']),
          initNow: TimeFormatter.formatDate(resInit[0].now.substring(0, 19)),
          initDays: initDays,
          initLocations: resInit[0].loc,
          activeLocation: resInit[0].loc.length > 0 && resInit[0].loc[0],
          tableStatus: 'LOAD'
        }, () => {
          this.initErtekesitesList();
        });
      }
    });
  }

  initErtekesitesList = (keys) => {
    console.log('basejson', this.state.baseJson)
    let baseJsonCopy = JSON.parse(JSON.stringify(this.state.baseJson));
    let intKeys = [];
    let resultKeys = [];
    if(keys) {
      baseJsonCopy.forEach((base) => {
        keys.forEach((key) => {
          if(base && base.id){
            if(base.id == key) intKeys.push(Number.parseInt(key))
          }
        });
      });
    }
    

    console.log('keys', keys, intKeys)
    return new Promise(res => {
      Services.getErtekesitesList(this.state.activeLocation.id, this.state.activeLocation.ids, this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(Moment(this.state.eloszuresKezdete).add(this.state.initDays,'d').toDate()), this.state.formElmultEsemenyek, keys, (errGet, resGet) => {
        if (!errGet) {
          let rendelesAdatok = JSON.parse(JSON.stringify(resGet[0]));
          let rendelesResults = [];
          let switchTime = resGet[0].length && TimeFormatter.formatDate(resGet[0][0].sta)
          let isDarker = false;
          let isChanged = true;
  
          rendelesAdatok.forEach(rendeles => {
            if(switchTime !== TimeFormatter.formatDate(rendeles.sta)) {
              isDarker = !isDarker;
              isChanged = true;
              switchTime = TimeFormatter.formatDate(rendeles.sta)
            }
            if(isChanged) {
              // KÉSZ FEATURE DÁTUM MEGJLENÍTÉS
              rendelesResults.push({
                enaDate: TimeFormatter.format(rendeles.sta, 'll - dddd'),
                isDatum: true,
                id: this.uuidv4()
              });
              isChanged = false;
            }
  
            rendeles.time = rendeles.sta;
            rendeles.korhatar = 16;
            rendeles.torolt = rendeles.sed + rendeles.std;
            rendeles.ervenyesitett = rendeles.sev + rendeles.stv;
            rendeles.fizetett = rendeles.sep + rendeles.stp;
            rendeles.foglalt = rendeles.ser + rendeles.str;
            rendeles.hna = rendeles.lid ? rendeles.hna + ' (' + (rendeles.cse + rendeles.cst) +  ')' : rendeles.hna;
            rendeles.darker = isDarker;
            rendelesResults.push(rendeles);
          });
  
          this.setState({
            tableStatus: resGet[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: rendelesResults,
          });
          res(rendelesResults);
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    })
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  getRendelesHelyszin = () => {
    Services.getRendelesHelyszin((err, res) => {
      if (!err) {
          let resHelyszin = res[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        this.setState({
          eloszuresHelyszin: res[0].length === 1 ? res[0][0].id : '',
          eloszuresHelyszinOptions: resHelyszin,
          eloszuresHelyszinOptionsData: res[0]
        }, () => {
          Services.getRendelesEsemeny(this.getHelyszinArray(this.state.eloszuresHelyszin), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(Moment(this.state.eloszuresKezdete).add(this.state.initDays,'d').toDate()), '', (err, res) => {
            if(!err) {
              this.setState({
                eloszuresEloadasOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nam + ' - ' + e.hna + ' (' + (e.sta ? TimeFormatter.formatLLLL(e.sta) : '') + ')'}</option>),
              });
            }
          });
        }
        )
      }
    });
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete, formTorlesOka: '' }));
  }

  toggleDeleteJegyModal = () => {
    this.setState(prevState => ({ modalJegyDelete: !prevState.modalJegyDelete, formTorlesJegyOka: '' }));
  }

  toggleEmailModal = () => {
    this.setState(prevState => ({ modalEmail: !prevState.modalEmail }));
  }

  togglePaymentModal = () => {
    this.setState(prevState => ({ modalPayment: !prevState.modalPayment }));
  }

  toggleFizetesModal = () => {
    this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }));
  }

  toggleNaptar = () => {
    this.setState(prevState => ({ isNaptarOpen: !prevState.isNaptarOpen }));
  }

  reOpenFizetesModal = () => {
    this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }), () => {
      this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }));
    });
  }

  toggleSecondScreen = () => {
    this.setState(prevState => ({ showSecondScreen: !prevState.showSecondScreen }));
  }

  toggleTeremberlesFizetesModal = (id) => {
    this.setState((prevState) => ({
      modalTeremBerlesFizetes: !prevState.modalTeremBerlesFizetes,
      currentTeremberlesId: id
    }));
  }

  isEmpty = (object) => {
    if (!object || object === '') return true;
    return false;
  }

  isEloszuresEmpty = () => {
    const {
      eloszuresSor,
      eloszuresCim,
      eloszuresEmail,
      eloszuresRendelesTipus,
      eloszuresRendelesAllapot,
      eloszuresKezdete,
      eloszuresVege
    } = this.state;
    if(this.isEmpty(eloszuresKezdete) && this.isEmpty(eloszuresVege) &&  this.isEmpty(eloszuresSor) && this.isEmpty(eloszuresCim) && this.isEmpty(eloszuresEmail) && this.isEmpty(eloszuresRendelesTipus) && this.isEmpty(eloszuresRendelesAllapot)) {
      return true;
    }
    return false;
  }

  getHelyszinArray = (helyszinid) => {
    let helyszinek = JSON.parse(JSON.stringify(this.state.eloszuresHelyszinOptionsData));
    let helyszin = helyszinek.find(x => x.id == helyszinid);
    if(helyszin && helyszin.ids) return helyszin.ids;
    return [];
  }

  getJegyekText = (ulohely, allohely) => {
    let resultText = ''
    if(allohely > 0) resultText += (allohely + ' db állóhely ')
    if(ulohely > 0) resultText += (ulohely + ' db ülőhely')
    return resultText.trim();
  }

  listMusor = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.getErtekesitesList(this.state.activeLocation.id, this.state.activeLocation.ids, this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(Moment(this.state.eloszuresKezdete).add(this.state.initDays,'d').toDate()), this.state.formElmultEsemenyek, [], (errGet, resGet) => {
        if (!errGet) {
          let rendelesAdatok = JSON.parse(JSON.stringify(resGet[0]));
          let rendelesResults = [];
          let switchTime =  resGet[0].length && TimeFormatter.formatDate(resGet[0][0].sta)
          let isDarker = false;
          let isChanged = true;

          rendelesAdatok.forEach(rendeles => {
            if(switchTime !== TimeFormatter.formatDate(rendeles.sta)) {
              isDarker = !isDarker;
              isChanged = true;
              switchTime = TimeFormatter.formatDate(rendeles.sta)
            }
            if(isChanged) {
              rendelesResults.push({
                enaDate: TimeFormatter.format(rendeles.sta, 'll - dddd'),
                isDatum: true,
                id: this.uuidv4()
              });
              isChanged = false;
            }

            rendeles.time = rendeles.sta;
            rendeles.korhatar = 16;
            rendeles.torolt = rendeles.sed + rendeles.std;
            rendeles.ervenyesitett = rendeles.sev + rendeles.stv;
            rendeles.fizetett = rendeles.sep + rendeles.stp;
            rendeles.foglalt = rendeles.ser + rendeles.str;
            rendeles.hna = rendeles.hna + ' (' + (rendeles.cse + rendeles.cst) +  ')';
            rendeles.darker = isDarker;
            rendelesResults.push(rendeles);
          });

          this.setState({
            tableStatus: resGet[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: rendelesResults,
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getRendeles = () => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getRendeles(this.state.currentId, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          formRendeloNev: this.nullToString(res[0].rendeloNev),
          formRendeloEmail: this.nullToString(res[0].rendeloEmail),
          formRendelesAllapot: this.nullToString(res[0].rendelesAllapot),
          formRendelesSorszam: this.nullToString(res[0].rendelesSorszam),
          formEsemenyKezdete: this.nullToString(res[0].esemenyKezdeteS),
          formEsemenyNev: this.nullToString(res[0].esemenyNev),

          formTerem: this.nullToString(res[0].helyszinTerem),
          formJegyadatok: res[0].jegyadatok

        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  getRendelesView = () => {
    this.setState({
      viewStatus: 'LOAD'
    });
    Services.getErtekesites(this.state.currentId, (err, res) => {
      if (!err) {
        this.setState({
          viewStatus: 'DATA',

          viewAge: this.nullToString(res[0].age),
          viewDescription: this.nullToString(res[0].des),
          viewTitle: this.nullToString(res[0].ena),
          viewEventProperty: this.nullToString(res[0].pro),
          viewRoom: this.nullToString(res[0].hna),
          viewLocation: this.nullToString(res[0].vna),

          viewEventStart: this.nullToString(res[0].sta),
          viewEventEnd: this.nullToString(res[0].end),

          viewPurchaseStart: this.nullToString(res[0].sst),
          viewPurchaseEnd: this.nullToString(res[0].sen),

          viewReservationStart: this.nullToString(res[0].est),
          viewReservationEnd: this.nullToString(res[0].een),

        });
      } else {
        this.setState({
          viewStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleCheckboxInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    }, () => {
      this.listMusor();
    });
  }

  // handleDateInputChange = (e, v, name) => {
  //   const value = v === '' ? null : v;
  //   this.setState({
  //     [name]: value
  //   }, () => {
  //     this.setState({ eloszuresEloadasOptions: [], eloszuresEloadas: '' }, () => {
  //       Services.getRendelesEsemeny(this.getHelyszinArray(this.state.eloszuresHelyszin), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(this.state.eloszuresVege), '', (err, res) => {
  //         if(!err) {
  //           this.setState({
  //             eloszuresEloadasOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nam + ' - ' + e.hna + ' (' + (e.sta ? TimeFormatter.formatLLLL(e.sta) : '') + ')'}</option>),
  //           });
  //         }
  //       });
  //     })
  //   });
  // }

  handleInputHelyszinChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
      eloszuresEloadasOptions: [],
      eloszuresEloadas: ''
    }, () => {
      Services.getRendelesEsemeny(this.getHelyszinArray(value), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(this.state.eloszuresVege), '', (err, res) => {
        if(!err) {
          this.setState({
            eloszuresEloadasOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nam + ' - ' + e.hna + ' (' + (e.sta ? TimeFormatter.formatLLLL(e.sta) : '') + ')'}</option>),
          });
        }
      });
    });
  }

  getFizetesInit = () => {
    this.setState({
      formFizetesStatus: 'LOAD'
    });
    Services.getFizetesInit(this.state.currentId, (err, res) => {
      if (!err) {
        this.setState({
          forFizetestipusOptions: res[0].pty.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          formFizetesStatus: 'DATA',
        });
      } else {
        this.setState({
          formFizetesStatus: 'NETW'
        });
      }
    });
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  handleEmailClick = (cell) => {
    Services.getEmail(cell, (err, res) => {
      if (!err) {
        this.setState({
          currentId: cell,
          currentEmail: res[0].ema,
          modalEmail: true
        });
      }
    });
  }

  handlePaymentClick = (cell) => {
    this.setState({
      currentId: cell,
      modalPayment: true,
      formFizetestipus: ''
    }, () => {
      this.getFizetesInit();
    });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getRendeles();
    });
  }

  handleViewClick = (cell) => {
    this.setState({
      currentId: cell,
      modalView: true
    }, () => {
      this.getRendelesView();
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      Services.checkRendelesDelete([cell], (err, res) => {
        if (!err) {
          this.setState({
            hasTorlesOka: res[0].result
          }, () => {
            this.toggleDeleteModal();
          })
        }
      });
    });
  }

  handleDeleteJegyClick = (cell) => {
    this.setState({
      torlesJegyId: cell
    }, () => {
      Services.checkJegyDelete([cell], (err, res) => {
        if (!err) {
          this.setState({
            hasTorlesOka: res[0].result
          }, () => {
            this.toggleDeleteJegyModal();
          })
        }
      });
    });
    // Services.deleteRendelesJegy([cell], (err) => {
    //   if (!err) {
    //     this.listMusor();
    //     this.props.globals.addSuccess('Jegy törölve!');
    //     this.getRendeles();
    //   }
    // });
  }

  handlePrintJegyClick = (cell) => {
    Services.getRendelesPrint1(cell, (err, res) => {
      if (!err) {
        let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          fileURL 
        }, () => {
          window.setTimeout(() => {

            window.frames["pdf-area-musor"].focus();
            window.frames["pdf-area-musor"].print();
            window.setTimeout(() => {
            window.close();
            }, 50);
          }, 1000);
        })
        this.props.globals.addSuccess('Jegy nyomtatás!');
      }
    });
  }

  handlePrintJegyekClick = (cell) => {
    Services.getRendelesPrint(cell, (err, res) => {
      if (!err) {
        let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        // window.open(fileURL, '_blank');
        // window.print();
        this.setState({
          fileURL 
        }, () => {
          window.setTimeout(() => {
            window.frames["pdf-area-musor"].focus();
            window.frames["pdf-area-musor"].print();
            window.setTimeout(() => {
            window.close();
            }, 50);
          }, 1000);
        })
        this.props.globals.addSuccess('Jegy nyomtatás!');
      }
    });
  }

  resendEmail = () => {
    this.setState({
      emailButtonLoading: true
    });
    Services.resendEmail(this.state.currentId, this.state.currentEmail, (err) => {
      if (!err) {
        this.toggleEmailModal();
        this.listMusor();
        this.props.globals.addSuccess('Email újraküldve!');
        this.setState({
          emailButtonLoading: false
        });
      } else {
        this.setState({
          emailButtonLoading: false
        });
      }
    });
  }

  deleteRendeles = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteRendeles(this.state.torlesId, this.emptyOrNull(this.state.formTorlesOka), (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listMusor();
        this.props.globals.addSuccess('Rendelés törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  deleteJegy = () => {
    this.setState({
      deleteJegyButtonLoading: true
    });
    Services.deleteRendelesJegy(this.state.torlesJegyId, this.emptyOrNull(this.state.formTorlesJegyOka), (err) => {
      if (!err) {
        this.toggleDeleteJegyModal();
        this.getRendeles();
        this.props.globals.addSuccess('Jegy törölve!');
        this.setState({
          deleteJegyButtonLoading: false
        });
      } else {
        this.setState({
          deleteJegyButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formRendeloNev: '',
      formRendeloEmail: '',
      formRendelesAllapot: '',
      formRendelesSorszam: '',
      formEsemenyKezdete: '',
      formEsemenyNev: '',
      formTerem: '',
      formFizetestipus: ''
    }, () => {
      this.toggleFormModal();
    });
  }

  handleEloadasListazas = () => {
    this.setState({ tovabbButtonLoading: true }, () => {
      this.setState({
        showVasarlas: true,
        showSecondScreen: true,
        tovabbButtonLoading: false,
      })
    });
  }

  handleEsemenyListazas = () => {
    this.setState({ listazasButtonLoading: true, formCurrentEsemeny: null, });
    Services.getRendelesEsemeny(this.state.formCurrentHelyszin.ids, this.dateToTimezone(this.state.rendelesKezdete), this.dateToTimezone(this.state.rendelesVege), this.state.rendelesCime, (err, res) => {
      if(!err) {
        this.setState({
          formCurrentEsemeny: null,
          formEsemenyCards: res[0],
          listazasButtonLoading: false,
        });
      } else {
        this.setState({
          formCurrentEsemeny: null,
          listazasButtonLoading: false,
        });
      }
    });
  }

  newRendelesClick = () => {
    this.setState({ rendelesButtonLoading: true });
    Services.getRendelesHelyszin((err, res) => {
      if(!err) {
        this.setState({ showVasarlas: false }, () => {
          this.setState({
            formCurrentHelyszin: res[0].length === 1 ? res[0][0] : null,
            formCurrentEsemeny: null,
            rendelesKezdete: TimeFormatter.formatDate(Moment()),
            rendelesVege: TimeFormatter.formatDate(Moment()),
            rendelesCime: '',
            formEsemenyCards: [],
            formHelyszinCards: res[0],
            rendelesButtonLoading: false,
            modalFizetes: true
          });
        })
      } else {
        this.setState({
          rendelesButtonLoading: false,
        });
      }
    });
  }

  onHelyszinClick = (item) => {
    this.setState({
      formCurrentHelyszin: item
    })
  }

  onEsemenyClick = (item) => {
    this.setState({
      formCurrentEsemeny: item
    })
  }

  pay = () => {
    this.setState({
      payButtonLoading: true
    })
    Services.rendelesFizetes(this.state.currentId, this.state.formFizetestipus, true, (err, res) => {
      if(!err) {
        this.setState({
          payButtonLoading: false,
          modalPayment: false
        });
        let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          fileURL 
        }, () => {
          window.setTimeout(() => {
            window.frames["pdf-area-musor"].focus();
            window.frames["pdf-area-musor"].print();
            window.setTimeout(() => {
            window.close();
            }, 50);
          }, 1000);
        })
        this.props.globals.addSuccess('Sikeres Fizetés!');
        this.listMusor();
      } else {
        this.setState({
          payButtonLoading: false,
        });
      }
    });
  }

  payWithoutPrint = () => {
    this.setState({
      payButtonLoading: true
    })
    Services.rendelesFizetes(this.state.currentId, this.state.formFizetestipus, false, (err, res) => {
      if(!err) {
        this.setState({
          payButtonLoading: false,
          modalPayment: false
        });
        this.props.globals.addSuccess('Sikeres Fizetés!');
        this.listMusor();
      } else {
        this.setState({
          payButtonLoading: false,
        });
      }
    });
  }

  submitForm = () => {
    const {
      currentId,
      formRendeloNev,
      formRendeloEmail,
      formType
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.nev = this.emptyOrNull(formRendeloNev);
      submitObj.email = this.emptyOrNull(formRendeloEmail);

      Services.editRendeles(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Rendelés módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listMusor();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'view'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'view'} delay={50}>
          {'Megtekintés'}
        </UncontrolledTooltip>
        {this.hasRole(['JEGYVASARLAS_RENDELES'], true) && (
          <React.Fragment>
            {row.mod && (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                  {'Módosítás'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.pay && (
              <React.Fragment>
                <Button className="icon-wallet table-action-icon" id={'action-view-' + cell + 'fizetes'} onClick={() => this.handlePaymentClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'fizetes'} delay={50}>
                  {'Fizetés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.ere && (
              <React.Fragment>
                <Button className="icon-envelope-letter table-action-icon" id={'action-view-' + cell + 'email'} onClick={() => this.handleEmailClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'email'} delay={50}>
                  {'E-mail újraküldés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.prn && (
              <React.Fragment>
                <Button className="icon-printer table-action-icon" id={'action-print-' + cell + 'jegyek'} onClick={() => this.handlePrintJegyekClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-print-' + cell + 'jegyek'} delay={50}>
                  {'Nyomtatás'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.del && (
              <React.Fragment>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                  {'Törlés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }

  tableJegyIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
        { row.jegyNyomtathato &&
          <React.Fragment>
            <Button className="icon-printer table-action-icon" id={'action-print-' + cell + 'jegy'} onClick={() => this.handlePrintJegyClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-print-' + cell + 'jegy'} delay={50}>
              {'Nyomtatás'}
            </UncontrolledTooltip>
          </React.Fragment>
        }

        { row.jegyTorolheto &&
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell + 'jegy'} onClick={() => this.handleDeleteJegyClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-delete-' + cell + 'jegy'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
            </React.Fragment>
          }
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  esemenyFormatter = (cell) => {
    let esemeny = cell.split('¤');
    return (
      <React.Fragment>
        <strong>
          {esemeny[0]}
        </strong>
        <p style={{ marginBottom: 2 }}>
          {esemeny[1]}
        </p>
        <p style={{ marginBottom: 2 }}>
          {esemeny[2]}
        </p>
        <div className="badge badge-info" style={{ whiteSpace: 'normal' }}>
          {esemeny[3] && TimeFormatter.formatLLLL(esemeny[3])}
        </div>
      </React.Fragment>
    )
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új rendelés létrehozása';
      case 'MOD':
        return 'Rendelés módosítása';
      default:
        return '';
    }
  }

  onXlsxClick = () => {
    this.setState({
      xlsxButtonLoading: true
    });
    Services.exportRendelesXlsx(this.node.filterContext.data.map( b =>  b.id ), (err, res) => {
      if (!err) {
        this.setState({
          xlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'rendeles_lista_.xlsx');
      } else {
        this.setState({
          xlsxButtonLoading: false
        });
      }
    });
  }

  onReszletesXlsxClick = () => {
    this.setState({
      reszletesXlsxButtonLoading: true
    });
    Services.exportReszletesRendelesXlsx(this.node.filterContext.data.map( b =>  b.id ), (err, res) => {
      if (!err) {
        this.setState({
          reszletesXlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'reszletes_rendeles_lista_.xlsx');
      } else {
        this.setState({
          reszletesXlsxButtonLoading: false
        });
      }
    });
  }

  tableDatumFormatter = (cell, row) => {
    if(row.isDatum) {
      return ''
    } else {
      return cell ? TimeFormatter.format(cell, 'll') + ' (' + TimeFormatter.format(cell, 'dddd') + ')' : '-';
    }
  }

  tableIdopontFormatter = (cell, row) => {
    if(row.isDatum) {
      return ''
    } else {
      return cell ? (
        <button className="btn btn-primary" style={{ width: 120 }} disabled={!row.act} onClick={() => {
          if (row.eid && row.act) {
            document.body.classList.add("sidebar-hidden");

            this.props.globals.route.navigate({
              pathname: `${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites/${row.eid}`,
              state: { eventId: row.eid, replace: true },
              search: 'rendelesek' in row && row.rendelesek.length === 1 ? '?rendelesId=' + row.rendelesek[0] : undefined
            });
          } else {
            this.toggleTeremberlesFizetesModal(row.id);
          }
        }}>
          {TimeFormatter.format(cell, 'LT')}
          {' '}
          {row.typ && Array.isArray(row.typ) && row.typ.map(icon => {
            return (
              <React.Fragment key={icon}>
                <i className={'fa ' + icon} aria-hidden="true"></i>
                {' '}
              </React.Fragment>
            )
          })}
        </button>
      ) : '-';
    }
  }

  statusbarFormatter = (cell, row) => {
    if (row.eid) {
      if(row.isDatum) {
        return ''
      } else {
        const all = row.foglalt + row.fizetett + row.ervenyesitett + row.torolt;
        const precents = {
          foglalt: all === 0 ? 25 : (row.foglalt / all) * 100,
          fizetett: all === 0 ? 25 : (row.fizetett / all) * 100,
          ervenyesitett: all === 0 ? 25 : (row.ervenyesitett / all) * 100,
          torolt: all === 0 ? 25 : (row.torolt / all) * 100,
        };
    
        return (
          <React.Fragment>
            <Progress multi style={{ height: 20, fontSize: 14 }}>
              <Progress bar color="szurke" value={this.minWidth(Math.round(precents.foglalt))}>{row.foglalt}</Progress>
              <Progress bar color="piros" value={this.minWidth(Math.round(precents.fizetett))}>{row.fizetett}</Progress>
              <Progress bar color="kek" value={this.minWidth(Math.round(precents.ervenyesitett))}>{row.ervenyesitett}</Progress>
              <Progress bar color="fekete" value={this.minWidth(Math.round(precents.torolt))}>{row.torolt}</Progress>
            </Progress>
          </React.Fragment>
        )
      }
    }
  }

  statusbar2Formatter = (cell, row) => {
    if (row.eid) {
      if(row.isDatum) {
        return ''
      } else {
        const all = row.cse;
        const precents = {
          rendelt: ((row.foglalt + row.fizetett + row.ervenyesitett) / row.cse) * 100,
          szabad: (row.cse - (row.foglalt + row.fizetett + row.ervenyesitett)) / row.cse * 100,
        };
    
        return (
          <React.Fragment>
            <Progress multi style={{ height: 20, fontSize: 14 }}>
              <Progress bar color="szurke" value={this.minWidth(Math.round(precents.rendelt))}>{row.foglalt + row.fizetett + row.ervenyesitett}</Progress>
              <Progress bar color="zold" value={this.minWidth(Math.round(precents.szabad))}>{((row.cse + row.cst) - (row.foglalt + row.fizetett + row.ervenyesitett))}</Progress>
            </Progress>
          </React.Fragment>
        )
      }
    }
  }

  minWidth = (number) => {
    return number < 10 && number > 0 ? 10 : number;
  }

  cimFormatter = (cell, row) => {
    if(row.isDatum) {
      return <h4 style={{
        position: 'absolute',
        left: 46
      }}>{row.enaDate}</h4>;
    } else {
      const randomText = row.pro;
      const randomShortText = row.pro ? randomText.length > 10 ? randomText.substring(0, 10) + '...' : randomText : '';
      return row.eid ? (
        <React.Fragment>
          <span id={'t' + row.eid}>
            {cell + ( (!this.isEmpty(randomShortText)) ? (' (' + randomShortText + ') ') : ' ')}
          </span>
          {(randomText && randomText !== '') && (
            <UncontrolledTooltip trigger='hover focus-visible' placement="top" target={'t' + row.eid}>
              {randomText}
            </UncontrolledTooltip>
          )}
          <KorhatarItem value={row.age} />
          {' '}
          <i className="fa fa-info" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={() => {
            this.handleViewClick(row.id);
          }}></i>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <span id={'t' + row.eid}>
            {cell + ( (!this.isEmpty(randomShortText)) ? (' (' + randomShortText + ') ') : ' ')}
          </span>
        </React.Fragment>
      )
    }
  }

  statusbarHeader = (cell, row) => {
    return (
      <div className='d-flex flex-wrap' style={{ gap: 4 }}>
        <span style={{ color: 'white', padding: '2px 8px', fontSize: 13, borderRadius: 5, backgroundColor: 'gray' }}>Foglalt</span>
        {' '}
        <span style={{ color: 'white', padding: '2px 8px', fontSize: 13, borderRadius: 5, backgroundColor: '#dc3545' }}>Fizetett</span>
        {' '}
        <span style={{ color: 'white', padding: '2px 8px', fontSize: 13, borderRadius: 5, backgroundColor: '#17a2b8' }}>Érvényesített</span>
        {' '}
        <span style={{ color: 'white', padding: '2px 8px', fontSize: 13, borderRadius: 5, backgroundColor: 'black' }}>Törölt</span>
      </div>
    )
  }
  
  statusbar2Header = (cell, row) => {
    return (
      <div className='d-flex flex-wrap' style={{ gap: 4 }}>
        <span style={{ color: 'white', padding: '2px 8px', fontSize: 13, borderRadius: 5, backgroundColor: 'gray' }}>Rendelt</span>
        {' '}
        <span style={{ color: 'white', padding: '2px 8px', fontSize: 13, borderRadius: 5, backgroundColor: '#47b560' }}>Szabad</span>
      </div>
    )
  }

  rowStyle = (row) => {
    const style = {};
    if (row.darker) {
      style.backgroundColor = '#eaeaea';
    } else {
      style.backgroundColor = '#fff';
    }

    if(row.isDatum) {
      style.border = 'none';
    }
  
    return style;
  };

  renderTable = () => {
    const options = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ],
    };


    const columns = [
      {
        dataField: 'time',
        text: 'Időpont',
        style: (cell, row, rowIndex, colIndex) => {
          if (row.isDatum) {
            return {
              border: 'none',
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
              width: 140
            };
          }
          return {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line',
            width: 140
          };
        },
        sort: false,
        formatter: this.tableIdopontFormatter
      },
      {
        dataField: 'ena',
        text: 'Esemény',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        // style: {
        //   wordBreak: 'break-word',
        //   whiteSpace: 'pre-line'
        // },
        style: (cell, row, rowIndex, colIndex) => {
          if (row.isDatum) {
            return {
              border: 'none',
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
              width: 380,
              height: 60
            };
          }
          return {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line'
          };
        },
        sort: false,
        formatter: this.cimFormatter
      },
      {
        dataField: 'sta',
        text: 'Kezdés dátuma',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: (cell, row, rowIndex, colIndex) => {
          if (row.isDatum) {
            return {
              minHeight: 50,
              border: 'none',
              wordBreak: 'break-word',
              whiteSpace: 'pre-line'
            };
          }
          return {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line'
          };
        },
        sort: false,
        formatter: this.tableDatumFormatter
      },
      {
        dataField: 'hna',
        text: 'Terem',
        csvExport: false,
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: (cell, row, rowIndex, colIndex) => {
          if (row.isDatum) {
            return {
              border: 'none',
              wordBreak: 'break-word',
              whiteSpace: 'pre-line'
            };
          }
          return {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line'
          };
        },
        sort: false
      },
      {
        dataField: 'hna1',
        text: 'Rendelt / Szabad',
        // filter: textFilter({
        //   delay: 400, // default is 500ms
        //   placeholder: 'Keresés...',
        // }),
        style: (cell, row, rowIndex, colIndex) => {
          if (row.isDatum) {
            return {
              border: 'none',
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
              width: 200
            };
          }
          return {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line',
            width: 200
          };
        },
        headerFormatter: this.statusbar2Header,
        formatter: this.statusbar2Formatter
      },
      {
        dataField: 'hna2',
        text: 'Foglalt / Fizetett / Érvényesített / Törölt',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: (cell, row, rowIndex, colIndex) => {
          if (row.isDatum) {
            return {
              border: 'none',
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
              width: 300
            };
          }
          return {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line',
            width: 300
          };
        },
        headerFormatter: this.statusbarHeader,
        formatter: this.statusbarFormatter
      },
      {
        dataField: 'id',
        csvExport: false,
        hidden: true,
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];  

    return (
      <div className="animated fadeIn">
        <ToolkitProvider
          exportCSV={{
            onlyExportFiltered: true,
            exportAll: false,
            fileName: 'rendelesek.csv',
            separator: ';',
            blobType: 'application/csv;charset=UTF-8',
            //noAutoBOM: true
          }}
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
        >
        {
          props => (
            <React.Fragment>
              {/* <ExportCSVButton { ...props.csvProps }>Export csv</ExportCSVButton>*/}
              <BootstrapTable
                { ...props.baseProps }
                ref={ n => this.node = n }
                bootstrap4
                filter={filterFactory()}
                // pagination={paginationFactory(Lib.bootstraptableProps)}
                wrapperClasses="table-responsive"
                classes="table-scroll"
                headerClasses="table-th"
                noDataIndication="Nincs megjelenítendő adat!"
                rowStyle={ this.rowStyle }
              />
            </React.Fragment>
            )
          }
          </ToolkitProvider>
      </div>
    );
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: e
    });
  }

  handleCalendarInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: e,
      formElmultEsemenyek: value < this.state.initNow,
    }, () => {
      this.listMusor();
    });
  }

  isNumeric = (value) => {
    return /^-{0,1}\d+$/.test(value);
  }

  handleOszetettInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    let valueIsNumeric = this.isNumeric(value);
    this.setState({
      [name]: value,
      keresesType: valueIsNumeric ? 'RENDELES' : 'NEVMAIL'
    });
  }

  handleRadioInputChange = (e) => {
    if (e.target) {
      this.setState({
        keresesType: e.target.value
      });
    }
  }

  clearFormValues = () => {
    this.setState({
      keresesType: 'NEVMAIL',
      eloszuresKereses: '',
      tableStatus: 'LOAD',
    }, () => {
      this.initErtekesitesList();
    });
  }

  handleOsszetettKeresesFormSubmit = () => {
    this.setState({ osszetettKeresesButtonLoading: true }, () => {
      Services.esemenyList({
        ids: this.state.activeLocation.ids,
        datum: TimeFormatter.formatDate(this.state.eloszuresKezdete),
        text: this.state.eloszuresKereses,
        tipus: this.state.keresesType === 'RENDELES',
        intervallum: this.state.initDays
      }, async (err, res) => {
        if (!err) {
          res = res[0];
          console.log('res0', res, res[0], Object.keys(res))
          const baseJson = await this.initErtekesitesList(Object.keys(res));

          this.setState({ osszetettKeresesButtonLoading: false }, () => {
            const newBaseJson = Object.keys(res)
              .map(key => {
                const found = baseJson.find(x => x.id == key);
                return found ? { ...found, rendelesek: res[key] } : null;
              })
              .filter(Boolean)
              .sort((a, z) => new Date(a.sta).getTime() - new Date(z.sta).getTime());

            if(newBaseJson.length === 1) {
              this.props.globals.route.navigate({
                pathname: this.props.globals.public_url + '/admin/jegyertekesites/helysziniertekesites/' + newBaseJson[0].eid, 
                search: newBaseJson[0].rendelesek.length === 1 ? '?rendelesId=' + newBaseJson[0].rendelesek[0] : undefined
              });
            }

            this.setState({ baseJson: newBaseJson });
          });
        } else {
          this.setState({ osszetettKeresesButtonLoading: false });
        }
      });
    });
  }

  handleCalendarChange = (e, v) => {
    this.handleCalendarInputChange(e, v, 'eloszuresKezdete');
    this.toggleNaptar();
  }

  handleCalendarKeyPress = (e) => {
    if (e.key === 'Enter') {
      const { value } = e.target;
      this.handleCalendarInputChange(value, value, 'eloszuresKezdete');
      this.toggleNaptar();
    }
  }

  renderEloszures = () => {
    const DayComponent = ({ date, label }) => (
      <div style={{
          color: date < Moment(this.state.eloszuresKezdete).add(this.state.initDays + 1,'d').toDate() && date > Moment(this.state.eloszuresKezdete).toDate() && 'white',
          backgroundColor: date < Moment(this.state.eloszuresKezdete).add(this.state.initDays + 1,'d').toDate() && date > Moment(this.state.eloszuresKezdete).toDate() && '#337ab7',
          borderColor: date < Moment(this.state.eloszuresKezdete).add(this.state.initDays + 1,'d').toDate() && date > Moment(this.state.eloszuresKezdete).toDate() && '#337ab7',
          padding: 5,
          borderRadius: 5
        }}
      >
        {label}
      </div>
    );

    const { eloszuresKezdete } = this.state;
    return (
      // <RFForm style={{ width: '100%' }} onSubmit={this.listMusor}>
        <div className='row align-items-end' style={{ marginBottom: 6, marginTop: 8 }}>
          <div className="col-12 col-xl-7" style={{ paddingBottom: 8 }}>
            <RFForm onSubmit={this.handleOsszetettKeresesFormSubmit}>
              <div className='d-flex' style={{ alignItems: 'flex-end', gap: 28 }}>
                <div className='col-md-4' style={{ padding: 0 }}>
                  <MusorContentOsszetettKeresesFormField
                    eloszuresKereses={this.state.eloszuresKereses}
                    onChange={this.handleOszetettInputChange}
                  />
                </div>
                <div>
                  <fieldset
                    id="rendeles-kereses-tipus"
                    name="keresesType"
                    required
                    errorMessage="Kötelező mező!"
                    style={{ fontSize: '13px' }}
                    value={this.state.keresesType}
                    onChange={(e, v) => this.handleRadioInputChange(e, v)}
                  >
                    <RFField type='radio' name='rendelestipus' label="Rendelésszám" value="RENDELES" checked={this.state.keresesType === 'RENDELES'} />
                    <RFField type='radio' name='rendelestipus' label="Név-email" value="NEVMAIL" checked={this.state.keresesType === 'NEVMAIL'} />
                  </fieldset>
                </div>
                <ProgressButton
                  style={{ marginBottom: 0 }}
                  color="primary"
                  className="table-new-button"
                  id="search-button"
                  loading={this.state.osszetettKeresesButtonLoading}
                >
                  {'Keresés'}
                </ProgressButton>

                <Button
                  style={{ marginBottom: 0, marginLeft: -20 }}
                  color="primary"
                  className="table-new-button"
                  onClick={() => this.clearFormValues()}
                  id="clear-form-values-button"
                  disabled={this.state.osszetettKeresesButtonLoading}
                >
                  <i className="fa fa-eraser" aria-hidden="true" />
                </Button>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'clear-form-values-button'} delay={50}>
                  {'Műsorlista alaphelyzetbe állítása'}
                </UncontrolledTooltip>
              </div>
            </RFForm>
          </div>

          <div className="col-12 col-xl-5 d-flex flex-column align-items-end mt-2">
            <div className="col-md-4 float-right">
              {this.state.initNow >= TimeFormatter.formatDate(this.state.eloszuresKezdete)
                && this.state.initNow <= TimeFormatter.formatDate(Moment(this.state.eloszuresKezdete).add(this.state.initDays,'d')) && (
                <FormGroup check className="pull-left noselect" style={{ float: 'right', fontSize: 15 }}>
                  <Label check style={{ whiteSpace: 'nowrap' }}>
                    <Input
                      type="checkbox"
                      id="formElmultEsemenyek"
                      name="formElmultEsemenyek"
                      checked={this.state.formElmultEsemenyek}
                      onChange={this.handleCheckboxInputChange}
                    />
                    {' '}
                    Elmúlt események megjelenítése
                  </Label>
                </FormGroup>
              )}
            </div>

            <div className='d-flex'>
              <div className="pull-right" style={{ border : '1px solid #acaee0', borderRadius: 5, height: 35, flexShrink: 0 }}>
                <i className="fa fa-arrow-left hover-gray" aria-hidden="true" style={{ padding: '10px' }}
                  onClick={() => {
                    this.setState(
                      prevState => ({ eloszuresKezdete: Moment(prevState.eloszuresKezdete).subtract(this.state.initDays + 1,'d').toDate() }),
                      () => { this.listMusor() }
                    );
                  }}
                ></i>
                <i id="naptarPopover" aria-hidden="true" className="fa fa-calendar hover-gray" style={{ padding: '10px' }} onClick={() => {
                }} />
                <Popover placement="bottom" trigger="legacy" isOpen={this.state.isNaptarOpen} target="naptarPopover" toggle={this.toggleNaptar} style={{ width: 270 }}>
                  <DatePicker
                    dayComponent={DayComponent}
                    onChange={this.handleCalendarChange}
                    onKeyPress={this.handleCalendarKeyPress}
                    value={eloszuresKezdete && new Date(eloszuresKezdete)}
                    name="eloszuresKezdete"
                    id="eloszuresKezdete"
                    defaultOpen
                  />
                </Popover>
                <i className="fa fa-arrow-right hover-gray" aria-hidden="true" style={{  padding: '10px' }}
                  onClick={() => {
                    this.setState(
                      prevState => ({ eloszuresKezdete: Moment(prevState.eloszuresKezdete).add(this.state.initDays + 1,'d').toDate() }),
                      () => { this.listMusor() }
                    );
                  }}
                ></i>
              </div>
              <Button
                style={{ marginBottom: 8, marginLeft: 8, borderColor: 'rgb(172, 174, 224)', width: 300 }}
                color="secondary"
                type="button"
                className="pull-right"
                onClick={(e) => {
                  e.target.blur();
                }}
              >
                {'Időszak: '}{TimeFormatter.format(eloszuresKezdete, 'LL')}{' + ' + (this.state.initDays) + ' nap'}
              </Button>
            </div>
          </div>
        </div>
      // </RFForm>
    );
  }

  renderFizetesForm = () => {
    const {
      currentId,
      formFizetestipus
    } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <FormGroup>
              <Label for="formFizetestipus">Fizetés típusa:</Label>
              <Input
                type="select"
                name="formFizetestipus"
                id="formFizetestipus"
                value={formFizetestipus}
                onChange={this.handleInputChange}
              >
                <option value="">Válassz típust...</option>
                {this.state.forFizetestipusOptions}
              </Input>
            </FormGroup>
          </div>
        </div>
      </React.Fragment>
    );
  }

  isActiveHelyszin = (id) => {
    if (this.state.formCurrentHelyszin) {
      if(id === this.state.formCurrentHelyszin.id) return true;
      return false;
    }
    return false;
  }

  isActiveEsemeny = (id) => {
    if (this.state.formCurrentEsemeny) {
      if(id === this.state.formCurrentEsemeny.id) return true;
      return false;
    }
    return false;
  }

  renderHelyszinCards = () => {
    return this.state.formHelyszinCards.map((item) => {
      return <HelyszinItem title={item.nev} active={this.isActiveHelyszin(item.id)} onClick={this.onHelyszinClick} item={item} key={item.id} />
    })
  }

  renderEsemenyCards = () => {
    return this.state.formEsemenyCards.map((item) => {
      return <EsemenyItem title={item.nam} active={this.isActiveEsemeny(item.id)} start={(item.sta ? TimeFormatter.formatLLLL(item.sta) : '')} room={item.hna} info={item.pro} onClick={this.onEsemenyClick} item={item} key={item.id} />
    })
  }

  renderForm = () => {
    const {
      currentId,
      formType,
      formStatusz,
      formRendeloNev,
      formRendeloEmail,
      formRendelesAllapot,
      formRendelesSorszam,
      formEsemenyKezdete,
      formEsemenyNev,
      formTerem,
      formFizetestipus,
    } = this.state;

    const titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-4">
              <RFField
                label={'Rendelő neve: *'}
                name="formRendeloNev"
                id="formRendeloNev"
                type="text"
                value={formRendeloNev}
                onChange={this.handleInputChange}
                required
              />
          </div>
          <div className="col-md-4">
              <RFField
                label={'Rendelő e-mail címe: *'}
                name="formRendeloEmail"
                id="formRendeloEmail"
                type="text"
                value={formRendeloEmail}
                onChange={this.handleInputChange}
                required
              />
          </div>
          <div className="col-md-4">
              <RFField
                label={'Státusz: '}
                name="formRendelesAllapot"
                id="formRendelesAllapot"
                type="text"
                value={formRendelesAllapot}
                disabled={formType === 'MOD'}
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <RFField
                label={'Rendelésszám: '}
                name="formRendelesSorszam"
                id="formRendelesSorszam"
                type="text"
                value={formRendelesSorszam}
                disabled={formType === 'MOD'}
              />
          </div>
          <div className="col-md-6">
              <RFField
                label={'Előadás időpontja: '}
                name="formEsemenyKezdete"
                id="formEsemenyKezdete"
                type="text"
                value={formEsemenyKezdete}
                disabled={formType === 'MOD'}
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <RFField
                label={'Előadás címe:'}
                name="formEsemenyNev"
                id="formEsemenyNev"
                type="text"
                value={formEsemenyNev}
                disabled={formType === 'MOD'}
              />
            {/* </AvGroup> */}
          </div>
          <div className="col-md-6">
              <RFField
                label={'Terem: '}
                name="formTerem"
                id="formTerem"
                type="text"
                value={formTerem}
                disabled={formType === 'MOD'}
              />
          </div>
        </div>
        <div className="row" style={{ borderBottom: '1px solid #dee2e6', marginBottom: 10 }}>
          <div className="col-md-12">
            <Button type="button" color="secondary" className="btn-cursor-pointer pull-right" onClick={this.toggleFormModal}>Mégsem</Button>
            <ProgressButton
              className="btn-cursor-pointer pull-right"
              color="primary"
              loading={this.state.saveButtonLoading}
              style={{
                marginBottom: 10,
                marginRight: 6
              }}
            >
              {'Mentés'}
            </ProgressButton>
          </div>
        </div>
        <div className="col-md-12">
          <h2>Jegyek:</h2>
        </div>
        <div>
          <div className="col-md-12">
            {
              {
                LOAD: <Loader />,
                DATA: (
                  <DataEmptyState hasImage subtitle="Használj más szűrést!" />
                ),
                NETW: (
                  <NetworkEmptyState
                    hasImage
                    submitClick={() => {
                      // this.listHelyszin();
                    }}
                  />
                ),
                TABL: this.renderFoglalasTable()
              }[this.state.tableStatus]
            }
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderView = () => {
    const {
      viewAge,
      viewDescription,
      viewTitle,
      viewEventProperty,
      viewRoom,
      viewLocation,

      viewEventStart,
      viewEventEnd,

      viewPurchaseStart,
      viewPurchaseEnd,

      viewReservationStart,
      viewReservationEnd,
    } = this.state;

    return (
      <React.Fragment>
        <h6>Műsor adatai:</h6>
        <b>Cím: </b>{viewTitle}<br /><br />

        <b>Tulajdonságok: </b>{viewEventProperty}<br />
        <b>Korhatár: </b>{viewAge}<br />
        <b>Helyszín: </b>{viewLocation}<br />
        <b>Terem: </b>{viewRoom}<br /><br />

        <b>Leírás: </b>{viewDescription}<br /><br />

        <b>Esemény kezdete: </b>{viewEventStart && TimeFormatter.format(viewEventStart, 'LLLL')}<br />
        <b>Esemény vége: </b>{viewEventEnd && TimeFormatter.format(viewEventEnd, 'LLLL')}<br /><br />

        <b>Vásárlás kezdete: </b>{viewPurchaseStart && TimeFormatter.format(viewPurchaseStart, 'LLLL')}<br />
        <b>Vásárlás vége: </b>{viewPurchaseEnd && TimeFormatter.format(viewPurchaseEnd, 'LLLL')}<br /><br />

        <b>Foglalás kezdete: </b>{viewReservationStart && TimeFormatter.format(viewReservationStart, 'LLLL')}<br />
        <b>Foglalás vége: </b>{viewReservationEnd && TimeFormatter.format(viewReservationEnd, 'LLLL')}<br />


        <br />
      </React.Fragment>
    )
  }

  renderFoglalasTable = () => {
    const columns = [
      {
        dataField: "jegySorszam",
        text: "Jegy \x0D sorszáma:",
        style: {
          whiteSpace: "pre-line"
        }
      },
      {
        dataField: "jegyHely",
        text: "Hely:",
        style: {
          whiteSpace: "pre-line"
        }
      },
      {
        dataField: "jegyTipus",
        text: "Jegytípus:",
        style: {
          whiteSpace: "pre-line"
        }
      },
      {
        dataField: "jegyArS",
        text: "Jegyár: ",
        style: {
          whiteSpace: "pre-line"
        }
      },
      {
        dataField: "jegyAllapot",
        text: "Állapot: ",
        style: {
          whiteSpace: "pre-line"
        }
      },
      {
        dataField: "id",
        text: "Műveletek",
        formatter: this.tableJegyIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.formJegyadatok}
          columns={columns}
          headerClasses="table-th"
          // cellEdit={ cellEditFactory({ mode: 'click' }) }
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  };

render() {
  const { showSecondScreen } = this.state
  return (
    <React.Fragment>
      <div>
        <iframe name="pdf-area-musor" id="pdf-area-musor" src={this.state.fileURL} style={{ visibility: 'hidden', height: 0, width: 0, position: 'absolute' }} />

        <div className="row">
          <div className='col-md-8'>
            <span style={{ fontSize: '1.4rem', paddingRight: 6 }}>
              {'Helyszín:'}
            </span>
            {' '}
            {this.state.initLocations.map((location) => {
              return (
                <Button
                  key={location.id.toString()}
                  style={{ marginBottom: 8, marginRight: 8 }}
                  color={location.id === this.state.activeLocation.id ? 'primary' : 'secondary'}
                  type="button"
                  onClick={() => {
                    this.setState({
                      activeLocation: location,
                      keresesType: 'NEVMAIL',
                      eloszuresKereses: '',
                    }, () => {
                      this.listMusor();
                    })
                  }}
                >
                  {location.nev}
                </Button>
              )
            })}
          </div>
        </div>

        {this.renderEloszures()}

        <div>
          {{
            QUERY: (<QueryEmptyState hasImage />),
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Válassz másik szűrési feltételt!"
            />),
            NETW: (<QueryEmptyState
              hasImage
              submitClick={() => { this.listMusor(); }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      {/* <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg"> */}
        <RFForm
          onSubmit={this.submitForm}
          modalInsert
          title={this.renderFormTitle()}
          tagProps={{ isOpen: this.state.modalForm, toggle: this.toggleFormModal, backdrop: 'static', size: 'lg' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer pull-right"
                color="primary"
                loading={this.state.saveButtonLoading}
                onClick={this.submitForm}
                style={{
                  marginBottom: 10,
                  marginRight: 6
                }}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer pull-right" onClick={this.toggleFormModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {/* <ModalHeader>{this.renderFormTitle()}</ModalHeader>
          <ModalBody> */}
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => {this.getRendeles()}}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
          {/* </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Bezárás</Button>
          </ModalFooter> */}
        </RFForm>
        {/* <Modal isOpen={this.state.modalJegyDelete} toggle={this.toggleDeleteJegyModal} backdrop="static"> */}
        <RFForm
          onSubmit={this.deleteJegy}
          modalInsert
          title={'Törlés'}
          tagProps={{ isOpen: this.state.modalJegyDelete, toggle: this.toggleDeleteJegyModal, backdrop: 'static' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.deleteJegyButtonLoading}
              >
                {'Törlés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleDeleteJegyModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
            {/* <ModalHeader>Törlés</ModalHeader>
            <ModalBody> */}
              <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott jegyet?</div>
              {this.state.hasTorlesOka && (
                <RFField label={'Törlés oka: *'} name="formTorlesJegyOka" id="formTorlesJegyOka" required value={this.state.formTorlesJegyOka} onChange={this.handleInputChange} />
              )}
            {/* </ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                // onClick={() => this.deleteRendeles()}
                loading={this.state.deleteJegyButtonLoading}
              >
                {'Törlés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleDeleteJegyModal}>Mégsem</Button>
            </ModalFooter> */}
            </RFForm>
          {/* </Modal> */}
      {/* </Modal> */}
      <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static" size="lg">
        <ModalHeader>Megtekintés</ModalHeader>
        <ModalBody>
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => {this.getRendelesView()}}
            />),
            DATA: (this.renderView())
          }[this.state.viewStatus]}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Bezárás</Button>
        </ModalFooter>
      </Modal>
      {/* <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static"> */}
      <RFForm
        onSubmit={this.deleteRendeles}
        modalInsert
        title={'Törlés'}
        tagProps={{ isOpen: this.state.modalDelete, toggle: this.toggleDeleteModal, backdrop: 'static' }}
        footer={
          <React.Fragment>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteRendeles()}
              loading={this.state.deleteButtonLoading}
            >
              {'Törlés'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </React.Fragment>
        }
      >
        {/* <ModalHeader>Törlés</ModalHeader>
        <ModalBody> */}
          <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott rendelést?</div>
          {this.state.hasTorlesOka && (
            <RFField label={'Törlés oka: *'} name="formTorlesOka" id="formTorlesOka" required value={this.state.formTorlesOka} onChange={this.handleInputChange} />
          )}
        {/* </ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            // onClick={() => this.deleteRendeles()}
            loading={this.state.deleteButtonLoading}
          >
            {'Törlés'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter> */}
        </RFForm>
      {/* </Modal> */}
      {/* <Modal isOpen={this.state.modalEmail} toggle={this.toggleEmailModal} backdrop="static"> */}
        <RFForm
          onSubmit={this.resendEmail}
          modalInsert
          title={'Email újraküldés'}
          tagProps={{ isOpen: this.state.modalEmail, toggle: this.toggleEmailModal, backdrop: 'static' }}
          footer={
            <React.Fragment>
              <ProgressButton
                type='submit'
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.resendEmail()}
                loading={this.state.emailButtonLoading}
              >
                {'Újraküldés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleEmailModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {/* <ModalHeader>Email újraküldés</ModalHeader>
          <ModalBody> */}
            <FormGroup>
              <RFField label={'Email cím:'} type="email" name="currentEmail" id="currentEmail" value={this.state.currentEmail} onChange={this.handleInputChange} />
            </FormGroup>
          {/* </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.resendEmail()}
              loading={this.state.emailButtonLoading}
            >
              {'Újraküldés'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleEmailModal}>Mégsem</Button>
          </ModalFooter> */}
        </RFForm>
      {/* </Modal> */}
      <Modal isOpen={this.state.modalPayment} toggle={this.togglePaymentModal} backdrop="static">
        <ModalHeader>Rendelés fizetése</ModalHeader>
        <ModalBody>
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => {}}
            />),
            DATA: (this.renderFizetesForm())
          }[this.state.formFizetesStatus]}
        </ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.pay()}
            loading={this.state.payButtonLoading}
          >
            {'Fizetés'}
          </ProgressButton>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.payWithoutPrint()}
            loading={this.state.payButtonLoading}
          >
            {'Fizetés nyomtatás nélkül'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.togglePaymentModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={this.state.modalFizetes} toggle={this.toggleFizetesModal} size="lg" backdrop="static">
        <ModalHeader>Új rendelés</ModalHeader>
        <ModalBody>
          {this.state.showVasarlas ? <JegyvasarlasContent id={this.state.formCurrentEsemeny.eid} globals={this.props.globals} /> : (
            <React.Fragment>
              <div className="row">
                <div className="col-md-12">
                  <h3>Helyszínek:</h3>
                </div>
              </div>
              <div className="row">
                {this.renderHelyszinCards()}
              </div>
              <div className="row">
                <div className="col-md-3">
                  <DatePicker
                    label="Esemény kezdete:"
                    containerClassName="organw-date-time"
                    time={false}
                    // format="YYYY-MM-DD"
                    messages={{ dateButton: "dátum", timeButton: "idő" }}
                    onChange={(e, v) => this.handleDateInputChange(e, v, 'rendelesKezdete')}
                    value={this.state.rendelesKezdete && new Date(this.state.rendelesKezdete)}
                    name="rendelesKezdete"
                    id="rendelesKezdete"
                  />
                </div>
                <div className="col-md-3">
                  <DatePicker
                    label="Esemény kezdete:"
                    containerClassName="organw-date-time"
                    time={false}
                    // format="YYYY-MM-DD"
                    messages={{ dateButton: "dátum", timeButton: "idő" }}
                    onChange={(e, v) => this.handleDateInputChange(e, v, 'rendelesVege')}
                    value={this.state.rendelesVege && new Date(this.state.rendelesVege)}
                    name="rendelesVege"
                    id="rendelesVege"
                  />
                </div>
                <div className="col-md-3">
                  <FormGroup>
                    <Label for="rendelesCime">Esemény címe:</Label>
                    <Input type="text" name="rendelesCime" id="rendelesCime" value={this.state.rendelesCime} onChange={this.handleInputChange} />
                  </FormGroup>
                </div>
                <div className="col-md-2">
                  <ProgressButton
                    style={{ marginBottom: 0, marginTop: 27 }}
                    className="pull-left table-new-button"
                    onClick={this.handleEsemenyListazas}
                    color="primary"
                    type="button"
                    loading={this.state.listazasButtonLoading}
                    disabled={!this.state.formCurrentHelyszin}
                  >
                    {'Listázás'}
                  </ProgressButton>
              </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <h3>Események:</h3>
                </div>
              </div>
              <div className="row">
                {this.renderEsemenyCards()}
              </div>
              <div className="row">
                <div className="col-md-12">
                  <ProgressButton
                    style={{ marginBottom: 0, marginTop: 27 }}
                    className="pull-right table-new-button"
                    disabled={!this.state.formCurrentEsemeny}
                    loading={this.state.tovabbButtonLoading}
                    onClick={this.handleEloadasListazas}
                    color="primary"
                    type="button"
                  >
                    {'Tovább'}
                  </ProgressButton>
                </div>
              </div>
            </React.Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={this.toggleFizetesModal}>Bezárás</Button>
        </ModalFooter>
      </Modal>
      <TeremberlesFizetesUrlap
        globals={this.props.globals}
        id={this.state.currentTeremberlesId}
        toggleFizetesModal={this.toggleTeremberlesFizetesModal}
        modalFizetes={this.state.modalTeremBerlesFizetes}
        hasFizKarbRole={this.props.globals.hasRoleSpec(['TEREMBERLES_FIZ_KARB'])}
        list={this.init} />
    </React.Fragment>
  );
}
}

MusorContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default MusorContent;
